import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { routerActions } from 'connected-react-router';

import { Col, Row } from 'react-bootstrap';

import { BrokerageList } from '../../components/BrokerageList';
import { UploadWhitelistContainer } from '../../../uploadWhitelist/containers';

import { fetchBrokerages } from '../../actions';

import _some from 'lodash/some';

import routes from '../../../constants/routes'

export class Brokerages extends Component {
    canManageBrokerages(user) {
        if (!user || !user.permissions) return false;
        return _some([
            user.permissions.includes('brokers:read'),
            user.permissions.includes('brokers:write')
        ]);
    }

    componentDidMount() {
        if (!this.canManageBrokerages(this.props.user)) {
            routerActions.push(routes.LOGIN);
        } else {
            this.props.fetchBrokerages();
        }
    }

    render() {
        return (
            <div className="homepageContainer">
                <div className="container">
                    <Row>
                        <Col>
                            <UploadWhitelistContainer />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="brokerages routeContainer">
                                <h3>Brokerages</h3>
                                <BrokerageList brokerages={this.props.brokerages} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

Brokerages.propTypes = {
    brokerages: PropTypes.array.isRequired,
    fetchBrokerages: PropTypes.func.isRequired,
    user: PropTypes.object
};

const mapStateToProps = store => {
    return {
        brokerages: store.brokerages.items,
        user: store.user
    };
};

export default connect(mapStateToProps, { fetchBrokerages })(Brokerages);
